import { httpClient, postProcessDelete } from "@genai/http-client";
import { AssistantId } from "../model";


export function deleteAssistant(assistantId: AssistantId) {
  return  httpClient(`/assistants/${assistantId}`, {
    method: "DELETE",
  }).then(postProcessDelete);
}
